import React, {useState, useEffect, useContext, useRef} from 'react'
import SearchBar from './searchBar'
import {useSelector, useDispatch} from 'react-redux'
import {Link, withRouter, useLocation} from 'react-router-dom'
import API from '../utils/API'
import CartHeader from './cartHeader'
import logo from '../assets/banner/lgaero.svg'
import logoNav from '../assets/img/aeromall_white.svg'
import {createBrowserHistory} from 'history'
import axiosClient from '../utils/API'

import {ContextApp} from '../context/ContextApp'

import imgVertical from '../assets/banner/catAeromall.jpg'
import Spinner from './SpinnerSearch'
import CloseDropDown from '../utils/CloseDropDown'

function HomeHeader(props) {
  const contextApp = useContext(ContextApp)
  const {
    CountProductLoad,
    resetProductSubCategories,
    resetProductCategories,
    paginate,
    categories,
    getProductsByCategory,
    categoryListShow,
    setCategoryShowOpen,
    deleteProductFromCarShopping,
    carShopping,
    setCategoryShowClose,
    getProductsBySearch,
    getSubCategories,
    subCategoriesList,
    getProductsBySubCategory,
    cleanProductsBySubCategory,
    getCategoryNameFromMenu,
    getProductsDiscount,
    getProductsFreeDelivery,
    contador,
    getProductsDiscountv2,
  } = contextApp

  const [showSearch, setShowSearch] = useState(false)

  const [openMenu, setOpenMenu] = useState(false)

  const history = createBrowserHistory()

  const handleSearch = () => {
    setShowSearch(false)
    getProductsBySearch(term)

    history.push('/product_search')
  }

  const [term, setTerm] = useState('')

  const handleChange = e => {
    setTerm(e.target.value)
  }

  const marketAe = categories.filter(category => category.id === 65)
  const listCategories = categories.filter(
    category => category.enabled == 1 && category.id !== 65,
  )

  /*const handleGetSubCategories = (id,categories) => {
        const subcategories = categories.subcategories.filter((category) => category.enabled === 1)

        getSubCategories(id,subcategories)
        console.log("Paso por el menu")
    }

    const handleMouseLeave = () => {
        cleanProductsBySubCategory()
    }*/

  const activeMenu = () => {
    setOpenMenu(!openMenu)
  }

  function handleKeyPress(event) {
    if(event.key === 'Enter' && term.trim() !== ''){
      setShowSearch(false)
      getProductsBySearch(term)
      setTerm('')

      props.history.push('/product_search')
    }
  }


  const location = useLocation()

  const [productsFound, setProductsFound] = useState([])
  const [productsNotFound, setProductsNotFound] = useState(false)
  const [filter, setFilter] = useState('P')
  async function searchProductByName(productName) {
    console.log(filter, term);
    try {
      const response = await axiosClient.post('/product-search', {
        "type": filter,
        "search": productName
      })
      if(response.status === 200 && response.data.length > 0) {
        setProductsFound(response.data)
      } else {
        setProductsNotFound(true)
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setProductsFound([])
    setProductsNotFound(false)
    if(term.length > 3) {
      searchProductByName(term, filter)

    }

  }, [term, filter])

  useEffect(() => {
    setTerm('')
  }, [location.pathname])
  

  //handle dropdown carshopping
  const [openCarShopping, setOpenCarShopping] = useState(false)
  return (
    <header id="header" class="u-header u-header-left-aligned-nav mb-4">
      <div class="u-header__section">
        <div class="bg-primary">
          <div class="container">
            <div class="row min-height-64 align-items-center position-relative">
              <div class="col-auto">
                <nav class="navbar navbar-expand u-header__navbar py-0 max-width-200 min-width-200">
                  <Link
                    to={'/'}
                    class="order-1 order-xl-0 navbar-brand u-header__navbar-brand u-header__navbar-brand-center"
                    aria-label="Electro"
                  >
                    <img src={logoNav} />
                  </Link>
                </nav>
                <aside
                  id="sidebarHeader1"
                  class="u-sidebar u-sidebar--left u-unfold--css-animation u-unfold--hidden"
                  aria-labelledby="sidebarHeaderInvokerMenu"
                  style={{animationDuration: '500ms'}}
                >
                  <div class="u-sidebar__scroller">
                    <div class="u-sidebar__container">
                      <div class="u-header-sidebar__footer-offset pb-0">
                        <div class="position-absolute top-0 right-0 z-index-2 pt-4 pr-7">
                          <button
                            type="button"
                            class="close ml-auto target-of-invoker-has-unfolds"
                            aria-controls="sidebarHeader"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-unfold-event="click"
                            data-unfold-hide-on-scroll="false"
                            data-unfold-target="#sidebarHeader1"
                            data-unfold-type="css-animation"
                            data-unfold-animation-in="fadeInLeft"
                            data-unfold-animation-out="fadeOutLeft"
                            data-unfold-duration="500"
                          >
                            <span aria-hidden="true">
                              <i class="ec ec-close-remove text-gray-90 font-size-20"></i>
                            </span>
                          </button>
                        </div>

                        <div
                          class="js-scrollbar u-sidebar__body mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
                          style={{position: 'relative', overflow: 'visible'}}
                        >
                          <div
                            id="mCSB_1"
                            class="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
                            style={{maxHeight: 'none'}}
                            tabindex="0"
                          >
                            <div
                              id="mCSB_1_container"
                              class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                              style={{
                                position: 'relative',
                                top: '0',
                                left: '0',
                              }}
                              dir="ltr"
                            >
                              <div
                                id="headerSidebarContent"
                                class="u-sidebar__content u-header-sidebar__content"
                              >
                                <a
                                  class="d-flex ml-0 navbar-brand u-header__navbar-brand u-header__navbar-brand-vertical"
                                  href="../home/index.html"
                                  aria-label="Electro"
                                >
                                  <svg
                                    version="1.1"
                                    x="0px"
                                    y="0px"
                                    width="175.748px"
                                    height="42.52px"
                                    viewBox="0 0 175.748 42.52"
                                    enable-background="new 0 0 175.748 42.52"
                                    style={{marginBottom: 0}}
                                  >
                                    <ellipse
                                      class="ellipse-bg"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      fill="#FDD700"
                                      cx="170.05"
                                      cy="36.341"
                                      rx="5.32"
                                      ry="5.367"
                                    ></ellipse>
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      fill="#333E48"
                                      d="M30.514,0.71c-0.034,0.003-0.066,0.008-0.056,0.056
                                                            C30.263,0.995,29.876,1.181,29.79,1.5c-0.148,0.548,0,1.568,0,2.427v36.459c0.265,0.221,0.506,0.465,0.725,0.734h6.187
                                                            c0.2-0.25,0.423-0.477,0.669-0.678V1.387C37.124,1.185,36.9,0.959,36.701,0.71H30.514z M117.517,12.731
                                                            c-0.232-0.189-0.439-0.64-0.781-0.734c-0.754-0.209-2.039,0-3.121,0h-3.176V4.435c-0.232-0.189-0.439-0.639-0.781-0.733
                                                            c-0.719-0.2-1.969,0-3.01,0h-3.01c-0.238,0.273-0.625,0.431-0.725,0.847c-0.203,0.852,0,2.399,0,3.725
                                                            c0,1.393,0.045,2.748-0.055,3.725h-6.41c-0.184,0.237-0.629,0.434-0.725,0.791c-0.178,0.654,0,1.813,0,2.765v2.766
                                                            c0.232,0.188,0.439,0.64,0.779,0.733c0.777,0.216,2.109,0,3.234,0c1.154,0,2.291-0.045,3.176,0.057v21.277
                                                            c0.232,0.189,0.439,0.639,0.781,0.734c0.719,0.199,1.969,0,3.01,0h3.01c1.008-0.451,0.725-1.889,0.725-3.443
                                                            c-0.002-6.164-0.047-12.867,0.055-18.625h6.299c0.182-0.236,0.627-0.434,0.725-0.79c0.176-0.653,0-1.813,0-2.765V12.731z
                                                            M135.851,18.262c0.201-0.746,0-2.029,0-3.104v-3.104c-0.287-0.245-0.434-0.637-0.781-0.733c-0.824-0.229-1.992-0.044-2.898,0
                                                            c-2.158,0.104-4.506,0.675-5.74,1.411c-0.146-0.362-0.451-0.853-0.893-0.96c-0.693-0.169-1.859,0-2.842,0h-2.842
                                                            c-0.258,0.319-0.625,0.42-0.725,0.79c-0.223,0.82,0,2.338,0,3.443c0,8.109-0.002,16.635,0,24.381
                                                            c0.232,0.189,0.439,0.639,0.779,0.734c0.707,0.195,1.93,0,2.955,0h3.01c0.918-0.463,0.725-1.352,0.725-2.822V36.21
                                                            c-0.002-3.902-0.242-9.117,0-12.473c0.297-4.142,3.836-4.877,8.527-4.686C135.312,18.816,135.757,18.606,135.851,18.262z
                                                            M14.796,11.376c-5.472,0.262-9.443,3.178-11.76,7.056c-2.435,4.075-2.789,10.62-0.501,15.126c2.043,4.023,5.91,7.115,10.701,7.9
                                                            c6.051,0.992,10.992-1.219,14.324-3.838c-0.687-1.1-1.419-2.664-2.118-3.951c-0.398-0.734-0.652-1.486-1.616-1.467
                                                            c-1.942,0.787-4.272,2.262-7.134,2.145c-3.791-0.154-6.659-1.842-7.524-4.91h19.452c0.146-2.793,0.22-5.338-0.279-7.563
                                                            C26.961,15.728,22.503,11.008,14.796,11.376z M9,23.284c0.921-2.508,3.033-4.514,6.298-4.627c3.083-0.107,4.994,1.976,5.685,4.627
                                                            C17.119,23.38,12.865,23.38,9,23.284z M52.418,11.376c-5.551,0.266-9.395,3.142-11.76,7.056
                                                            c-2.476,4.097-2.829,10.493-0.557,15.069c1.997,4.021,5.895,7.156,10.646,7.957c6.068,1.023,11-1.227,14.379-3.781
                                                            c-0.479-0.896-0.875-1.742-1.393-2.709c-0.312-0.582-1.024-2.234-1.561-2.539c-0.912-0.52-1.428,0.135-2.23,0.508
                                                            c-0.564,0.262-1.223,0.523-1.672,0.676c-4.768,1.621-10.372,0.268-11.537-4.176h19.451c0.668-5.443-0.419-9.953-2.73-13.037
                                                            C61.197,13.388,57.774,11.12,52.418,11.376z M46.622,23.343c0.708-2.553,3.161-4.578,6.242-4.686
                                                            c3.08-0.107,5.08,1.953,5.686,4.686H46.622z M160.371,15.497c-2.455-2.453-6.143-4.291-10.869-4.064
                                                            c-2.268,0.109-4.297,0.65-6.02,1.524c-1.719,0.873-3.092,1.957-4.234,3.217c-2.287,2.519-4.164,6.004-3.902,11.007
                                                            c0.248,4.736,1.979,7.813,4.627,10.326c2.568,2.439,6.148,4.254,10.867,4.064c4.457-0.18,7.889-2.115,10.199-4.684
                                                            c2.469-2.746,4.012-5.971,3.959-11.063C164.949,21.134,162.732,17.854,160.371,15.497z M149.558,33.952
                                                            c-3.246-0.221-5.701-2.615-6.41-5.418c-0.174-0.689-0.26-1.25-0.4-2.166c-0.035-0.234,0.072-0.523-0.045-0.77
                                                            c0.682-3.698,2.912-6.257,6.799-6.547c2.543-0.189,4.258,0.735,5.52,1.863c1.322,1.182,2.303,2.715,2.451,4.967
                                                            C157.789,30.669,154.185,34.267,149.558,33.952z M88.812,29.55c-1.232,2.363-2.9,4.307-6.13,4.402
                                                            c-4.729,0.141-8.038-3.16-8.025-7.563c0.004-1.412,0.324-2.65,0.947-3.726c1.197-2.061,3.507-3.688,6.633-3.612
                                                            c3.222,0.079,4.966,1.708,6.632,3.668c1.328-1.059,2.529-1.948,3.9-2.99c0.416-0.315,1.076-0.688,1.227-1.072
                                                            c0.404-1.031-0.365-1.502-0.891-2.088c-2.543-2.835-6.66-5.377-11.704-5.137c-6.02,0.288-10.218,3.697-12.484,7.846
                                                            c-1.293,2.365-1.951,5.158-1.729,8.408c0.209,3.053,1.191,5.496,2.619,7.508c2.842,4.004,7.385,6.973,13.656,6.377
                                                            c5.976-0.568,9.574-3.936,11.816-8.354c-0.141-0.271-0.221-0.604-0.336-0.902C92.929,31.364,90.843,30.485,88.812,29.55z"
                                    ></path>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            id=""
                            class="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal-dark mCSB_scrollTools_vertical"
                            style={{display: 'none'}}
                          >
                            <div class="mCSB_draggerContainer">
                              <div
                                id="mCSB_1_dragger_vertical"
                                class="mCSB_dragger"
                                style={{
                                  position: 'absolute',
                                  minHeight: '50px',
                                  top: '0px',
                                  display: 'block',
                                  height: '99px',
                                  maxHeight: '168px',
                                }}
                              >
                                <div
                                  class="mCSB_dragger_bar"
                                  style={{lineHeight: '50px'}}
                                ></div>
                              </div>
                              <div class="mCSB_draggerRail"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </aside>
              </div>

              <div class="col d-none d-xl-block search-input-global" style={{width: '200px'}}>
                <div class="input-group" onKeyPress={handleKeyPress}>
                  <select className="select-search-by-depending" onChange={(e) => setFilter(e.target.value)}>
                    <option value="P">Productos</option>
                    <option value="C">Comercios</option>
                  </select>
                  <input
                    type="text"
                    class="form-control py-2 pl-5 font-size-15 border-right-0 height-42 border-width-0 rounded-left-pill border-primary"
                    placeholder="Buscar Productos"
                    onChange={e => handleChange(e)}
                  />
                  <Link
                    to={'/product_search'}
                    onClick={handleSearch}
                    class="btn btn-dark height-42 py-2 px-3 rounded-right-pill"
                    type="button"
                    id="search_button"
                  >
                    <span on class="ec ec-search font-size-20"></span>
                  </Link>
                </div>
                {term.trim().length > 3 ? (
                  <div className="list-search-by-product-aboslute">
                    {productsFound.length > 0 ? (
                        productsFound.map(product => {
                          console.log(product);
                          return (
                            <Link to={filter === 'P' ? `/productos/general/${product.slug}/${product.id}` : `/store/company/${product.slug}/${product.id}`}>
                              <a href="#">{product.name}</a>                                          
                            </Link>
                          )
                        })
                      ) : productsNotFound ? <span>No se encontraron productos</span> : <Spinner />}
                  </div>
                ) : null}
              </div>

              <div class="col col-xl-auto text-right text-xl-left pl-0 pl-xl-3 position-static">
                <div class="d-inline-flex">
                  <ul class="d-flex list-unstyled mb-0 align-items-center">
                    <li class="col d-xl-none px-2 px-sm-3 position-static">
                      <a
                        id="searchClassicInvoker"
                        class="font-size-22 text-gray-90 text-lh-1 btn-text-secondary"
                        href="javascript:;"
                        role="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        aria-controls="searchClassic"
                        aria-haspopup="true"
                        aria-expanded="false"
                        data-unfold-target="#searchClassic"
                        data-unfold-type="css-animation"
                        data-unfold-duration="300"
                        data-unfold-delay="300"
                        data-unfold-hide-on-scroll="true"
                        data-unfold-animation-in="slideInUp"
                        data-unfold-animation-out="fadeOut"
                        data-original-title="Search"
                      >
                        <span class="ec ec-search"></span>
                      </a>

                      <div
                        id="searchClassic"
                        class="dropdown-menu dropdown-unfold dropdown-menu-right left-0 mx-2 u-unfold--css-animation u-unfold--hidden fadeOut"
                        aria-labelledby="searchClassicInvoker"
                        style={{animationDuration: '300ms'}}
                      >
                        <form class="js-focus-state input-group px-3">
                          <input
                            class="form-control"
                            type="search"
                            placeholder="Search Product"
                          />
                          <div class="input-group-append">
                            <button class="btn btn-primary px-3" type="button">
                              <i class="font-size-18 ec ec-search"></i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </li>

                    <li class="col d-xl-none px-2 px-sm-3">
                      <a
                        class="text-gray-90"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-original-title="My Account"
                      >
                        <i class="font-size-22 ec ec-user"></i>
                      </a>
                    </li>

                    <li class="nav-item dropdown">
                      <a class="nav-link" style={{cursor: 'pointer'}} onClick={() => setOpenCarShopping(true)}>
                        <i
                          class="ec ec-shopping-bag"
                          style={{
                            fontSize: '1.5rem',
                            marginTop: '-5px',
                          }}
                        ></i>
                        <span class="cart-items-count count">
                          {carShopping.length}
                        </span>
                        {/* <span class="cart-items-total-price total-price"><span class="amount">{total}</span></span> */}
                      </a>
                      {openCarShopping && (
                        <>
                        <CloseDropDown setClose={setOpenCarShopping} />
                        <ul
                          class="wrapper-car-shopping"
                          style={{marginLeft: '-150px'}}
                        >
                          <li>
                            <div class="widget_shopping_cart_content">
                              <ul class="cart_list product_list_widget ">
                                {carShopping?.map(product => {
                                  return (
                                    <li class="mini_cart_item">
                                      <a
                                        title="Remove this item"
                                        class="remove"
                                        href="#"
                                        onClick={() =>
                                          deleteProductFromCarShopping(product.id)
                                        }
                                      >
                                        ×
                                      </a>
                                      <a href="#">
                                        <img
                                          class="attachment-shop_thumbnail size-shop_thumbnail wp-post-image"
                                          src={product?.image_url}
                                          alt=""
                                        />
                                        {product?.name}
                                      </a>
                                      <span class="quantity" style={{color: 'black'}}>
                                        {product.cantidadCli} x
                                        <span class="amount" style={{color: 'black'}}>
                                          <ins>
                                            <span
                                              className="amount"
                                              style={{margin: '5px'}}
                                            >
                                              {' '}
                                              {`$${product?.batches[0].regular_price}`}
                                            </span>
                                          </ins>
                                        </span>
                                      </span>
                                    </li>
                                  )
                                })}
                              </ul>
                              {/* <p class="total">
                                <strong>Subtotal:</strong>{' '}
                                <span class="amount">45</span>
                              </p> */}
                              <p class="buttons">
                                <Link to={'/cart'} class="button wc-forward">
                                  Ver Carrito
                                </Link>
                                <Link to={'/checkout'} class="button wc-forward">
                                  Pagar
                                </Link>
                              </p>
                            </div>
                          </li>
                        </ul>
                        </>
                      )}
                      
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          
        </div>

        <div class="box-shadow-1 d-none d-xl-block">
          <div class="container">
            <div class="row" style={{height: '37px'}}>
              <div class="col-md-auto d-none d-xl-block align-self-center">
                <div class="max-width-200 min-width-200">
                  <div id="basicsAccordion">
                    <div class="card border-0">
                      <div
                        class="card-header card-collapse btn-remove-bg-hover border-0"
                        id="basicsHeadingOne"
                      >
                        <button
                          type="button"
                          class="btn-link btn-remove-bg-hover btn-block d-flex card-btn pyc-10 text-lh-1 pl-0 pr-4 shadow-none btn-primary bg-transparent rounded-top-lg border-0 font-weight-bold text-gray-90"
                          data-toggle="collapse"
                          data-target="#basicsCollapseOne"
                          aria-expanded="false"
                          aria-controls="basicsCollapseOne"
                          onClick={activeMenu}
                        >
                          <span class="text-gray-90">
                            Todas las categorías{' '}
                          </span>
                          <span class="ml-2 text-gray-90">
                            <span class="ec ec-arrow-down-search"></span>
                          </span>
                        </button>
                      </div>
                      <div
                        id="basicsCollapseOne"
                        class={
                          openMenu == true
                            ? 'show collapse vertical-menu v2'
                            : 'collapse vertical-menu v2'
                        }
                        aria-labelledby="basicsHeadingOne"
                        data-parent="#basicsAccordion"
                      >
                        <div class="card-body p-0">
                          <nav class="js-mega-menu navbar navbar-expand-xl u-header__navbar u-header__navbar--no-space hs-menu-initialized">
                            <div
                              id="navBar"
                              class="collapse navbar-collapse u-header__navbar-collapse"
                            >
                              <ul class="navbar-nav u-header__navbar-nav border-top-primary">
                                <li
                                  class="nav-item u-header__nav-item"
                                  data-event="hover"
                                  data-position="left"
                                ></li>
                                {categories.length === 0 ? null : (
                                  <>
                                    {listCategories.map((category, index) => (
                                      <li
                                        key={categories[1].id}
                                        class="nav-item hs-has-mega-menu u-header__nav-item"
                                        data-event="hover"
                                        data-animation-in="slideInUp"
                                        data-animation-out="fadeOut"
                                        data-position="left"
                                      >
                                        <Link
                                          id={index}
                                          to={{
                                            pathname: `/productos/${category.slug}/${category.id}`,
                                            state: category
                                          }}
                                          style={{cursor: 'pointer'}}
                                          class="nav-link u-header__nav-link"
                                          aria-haspopup="true"
                                          aria-expanded="false"
                                          onClick={() => {
                                            resetProductCategories()
                                            CountProductLoad(0)
                                            getProductsByCategory(
                                              category.id,
                                              category,
                                              category.name,
                                              paginate,
                                              0,
                                              0,
                                              0,
                                            )
                                            //resetRealoadProductsByCategory()
                                            activeMenu()
                                          }}
                                        >
                                          {category.name}{' '}
                                          {category.subcategories.length ==
                                          0 ? null : (
                                            <i class="fas fa-chevron-right">
                                              {' '}
                                            </i>
                                          )}
                                        </Link>

                                        {category.subcategories.length ==
                                        0 ? null : (
                                          <div
                                            class="hs-mega-menu vmm-tfw u-header__sub-menu"
                                            aria-labelledby={index}
                                          >
                                            <div class="vmm-bg">
                                              {/* <img class="img-fluid" src={imgVertical} width="234px" alt="Image Description" /> */}
                                            </div>
                                            <div class="row u-header__mega-menu-wrapper">
                                              <div class="col mb-3 mb-sm-0">
                                                <span class="u-header__sub-menu-title">
                                                  {category.name}
                                                </span>
                                                <ul class="u-header__sub-menu-nav-group mb-3">
                                                  {category.subcategories.map(
                                                    (subCategory, index) =>
                                                      subCategory.enabled ==
                                                      1 ? (
                                                        <>
                                                          <li
                                                            id={index}
                                                            style={{
                                                              cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                              //resetProductSubCategories()
                                                              CountProductLoad(
                                                                0,
                                                              )
                                                              getProductsBySubCategory(
                                                                subCategory.id,
                                                                category,
                                                                subCategory.name,
                                                                paginate,
                                                                0,
                                                                0,
                                                                0,
                                                              )
                                                              activeMenu()
                                                            }}
                                                          >
                                                            <Link
                                                              id={index}
                                                              to={`/productos/subcategoria/${subCategory.slug}/${subCategory.id}`}
                                                              className="nav-link u-header__sub-menu-nav-link"
                                                              style={{
                                                                cursor:
                                                                  'pointer',
                                                              }}
                                                            >
                                                              {subCategory.name}
                                                            </Link>
                                                          </li>
                                                        </>
                                                      ) : null,
                                                  )}
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </li>
                                    ))}
                                    {marketAe.map(category => (
                                      <li
                                        key={categories[1].id}
                                        class="nav-item hs-has-mega-menu u-header__nav-item"
                                        data-event="hover"
                                        data-animation-in="slideInUp"
                                        data-animation-out="fadeOut"
                                        data-position="left"
                                      >
                                        <Link
                                          class="nav-link u-header__nav-link"
                                          aria-haspopup="true"
                                          aria-expanded="false"
                                          aria-haspopup="true"
                                        >
                                          {category.name}{' '}
                                          <i class="fas fa-chevron-right"></i>
                                        </Link>

                                        {category.subcategories.length ==
                                        0 ? null : (
                                          <div
                                            class="hs-mega-menu vmm-tfw u-header__sub-menu"
                                            aria-labelledby="index"
                                          >
                                            <div class="vmm-bg">
                                              {/* <img class="img-fluid" src={imgVertical} width="234px" alt="Image Description" /> */}
                                            </div>
                                            <div class="row u-header__mega-menu-wrapper">
                                              <div class="col mb-3 mb-sm-0">
                                                <span class="u-header__sub-menu-title">
                                                  {category.name}
                                                </span>
                                                <ul class="u-header__sub-menu-nav-group mb-3">
                                                  {category.subcategories.map(
                                                    subCategory => (
                                                      <li
                                                        onClick={() => {
                                                          resetProductSubCategories()
                                                          getProductsBySubCategory(
                                                            subCategory.id,
                                                            category,
                                                            subCategory.name,
                                                            paginate,
                                                            0,
                                                            0,
                                                            0,
                                                          )
                                                          activeMenu()
                                                        }}
                                                      >
                                                        <Link
                                                          to={`/products/subcategory/${subCategory.name}`}
                                                          className="nav-link u-header__sub-menu-nav-link"
                                                        >
                                                          {subCategory.name}
                                                        </Link>
                                                      </li>
                                                    ),
                                                  )}
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </li>
                                    ))}
                                  </>
                                )}
                              </ul>
                            </div>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*
                    <div class="col secondary-menu">
                     
                        <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space hs-menu-initialized hs-menu-horizontal">
                        
                            <div id="navBar" class="collapse navbar-collapse u-header__navbar-collapse">
                                <ul class="navbar-nav u-header__navbar-nav">
                           
                                    <li class="nav-item hs-has-mega-menu u-header__nav-item" data-event="click" data-animation-in="slideInUp" data-animation-out="fadeOut" data-position="left">
                                        <Link id="homeMegaMenu" class="nav-link u-header__nav-link  text-sale" href="javascript:;" aria-haspopup="true" aria-expanded="false">Super Ofertas</Link>  
                                    </li>
                         
                                
                                    <li class="nav-item u-header__nav-last-item">
                                        <a class="text-gray-90" href="#" target="_blank">
                                        Free Delivery en productos seleccionados
                                        </a>
                                    </li>
                                   
                                </ul>
                            </div>
              
                        </nav>
           
                    </div>
                    */}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default withRouter(HomeHeader)